/**
  *   Rocket - Dani
  */

let url;

/* Give apps container add class .container */

const judge_container = document.getElementById('judgeme_product_reviews');
if(judge_container){
  judge_container.classList.add('container');
}

const instafeed = document.getElementById("insta-feed");

/* Give instafeed custom title */
const rocket_section = document.getElementsByClassName("shopify-section--rocket-instafeed");
if( instafeed != null && rocket_section.length <= 0){
  //Add container
  instafeed.classList.add('container');

  //Modify instafeed DOM Manipulation
  instafeed.parentElement.parentElement.parentElement.classList.add('instafeed-section'); 

  let instafeed_title_container = document.createElement('div');
  instafeed_title_container.classList.add('instafeed-title');
   
  const browserLanguage = navigator.language; // replace here with variable from translation app
  const span_lmm = ' <span class="color-secondary">@leminimacaron</span>';
   
  let instafeed_custom_text = 'Follow us on Instagram'+span_lmm;
  if (browserLanguage === 'es' || browserLanguage === 'es-ES') instafeed_custom_text = 'Síguenos en Instagram'+span_lmm;
  if (browserLanguage === 'it' || browserLanguage === 'it_IT') instafeed_custom_text = 'Seguici su Instagram'+span_lmm;

  const instafeed_title = '<div class="container"><h3 class="h4">'+instafeed_custom_text+'</h3></div>';

  instafeed_title_container.innerHTML = instafeed_title;
  
  instafeed.parentElement.insertBefore(instafeed_title_container, instafeed); 
}

/* Mobile dropdown */

let dropdown = document.getElementsByClassName("dropdown-custom");

for(i = 0; i < dropdown.length; i++){
  dropdown[i].addEventListener('click', function(){

    second_child = this.querySelector('.menu-filter__list');
    second_child_height = second_child.offsetHeight;

    first_child = this.querySelector('.dropdown-inner')

    if(this.classList.contains('dropdown-open')){
      this.classList.remove('dropdown-open');
      first_child.style.height = 0;
    }else{
      this.classList.add('dropdown-open');
      first_child.style.height = second_child_height+'px';
    }

  });
};

/**
  *   JQUERY 
 */

$(function(){

  /* Hide smile on mobile version */

  let menu_toggle = $('[data-menu-toggle]');
  let smile = '#smile-ui-container';

  menu_toggle.on('click',function(){
    $('body').find(smile).fadeToggle();
  })

  /* Give shade filter value for slider appearance */

  let slider = document.getElementById("myRange");
  let collection_container = $('.collection-grid');
  let reset = document.getElementById('reset_filter_custom');

  if(slider){

    // Slider URL on change
    let slider_filtering = function (){
      url = slider.dataset.url;

      //smooth slider values
      slider_value = slider.value;

      if(slider_value < 1.49){
        slider_value = 1;
      }else if(slider_value < 2.49){
        slider_value = 2;
      }else if(slider_value < 3.49){
        slider_value = 3;
      }else if(slider_value < 4.49){
        slider_value = 4;
      }else{
        slider_value = 5;
      }

      //Go to collection URL + filter
      url += slider_value;
  
      $.ajax({
          url:url,
          type:'GET',
          dataType:'html',
          beforeSend: function(){
            $('.collection-grid').html('');
            $('#collection_loading').show();
          },
          complete: function(){
            $('#collection_loading').hide();
          },
      }).done(function(next_page){
          let new_articles = $(next_page).find('.collection-grid');
          collection_container.html(new_articles.html());

          reset.classList.remove('d-none');
      });
    }

    slider.onclick = slider_filtering;
    slider.ontouchend = slider_filtering;

    let show_slider_handle = function (){
      //Show slider handle if hidden
      if(slider.classList.contains('slider-handle-hidden')){
        slider.classList.remove('slider-handle-hidden');
      }
    }
    // Show slider handle when mousedown
    slider.onmousedown = show_slider_handle;
    slider.ontouchstart = show_slider_handle;

    /*

    NOT USED ATM
    
    let search_params = new URL(window.location.href);
    let capture_reset = search_params.searchParams.get('reset');

    if( capture_reset != null && capture_reset){
      let scroll_container = document.getElementById('section--filter-by-shade');
      let scroll_to = window.pageYOffset + scroll_container.getBoundingClientRect().top - 60;

      //let scroll_to = scroll_container.offsetHeight;

      window.scrollTo({
        top: scroll_to,
        behavior: 'smooth'
      })
    }
    */   
  }

  /* AJAX call for blog articles tag search */
   
  let blog_articles = $('.blog-filter__content a');
   
  if(blog_articles){
    blog_articles.on('click',function(e){
      e.preventDefault();
      
      if(!$(this).parent('li').hasClass('filter_active')){
        $('.blog-filter__content li').removeClass('filter_active');
        $(this).parent('li').addClass('filter_active');
      }
      
      let blogs_on_page = $('.blogs_on_page');
      url = $(this).attr('href');
      
      $.ajax({
        url:url,
        type:'GET',
        dataType:'html'
      }).done(function(next_page){
        let new_articles = $(next_page).find('.blogs_on_page');
        blogs_on_page.html(new_articles.html());
      });
    });
  }

  /* Sort faqs */
  let faq_filters = $('.faqs-filter__content a');

  if(faq_filters){
    faq_filters.on('click',function(e){
      e.preventDefault();
      if(!$(this).parent('li').hasClass('filter_active')){
        $('.faqs-filter__content li').removeClass('filter_active');
        $(this).parent('li').addClass('filter_active');
      }
      
      let tag = $(this).data('faq-tag');
      $('.faq-list__item').show();

      if(tag != 'all'){
        $('.faq-list__item:not(.faq--'+tag+')').hide();
      }
    });
  }
  
  /* Give main a min-height of 100vh - footer height | FUNCTION called after every image is loaded */

  let imgs = document.images,
    len = imgs.length,
    counter = 0;

  [].forEach.call( imgs, function( img ) {
      if(img.complete)
        incrementCounter();
      else
      img.addEventListener( 'load', incrementCounter, false );
    } 
  );

  function incrementCounter() {
    counter++;
    if ( counter === len ) {

      /* Change prev/next button icons */
      let next_button = document.querySelectorAll('.flickity-prev-next-button');
      
      let arrow_svg = `
        <svg width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M9.46967 5.46967C9.76256 5.17678 10.2374 5.17678 10.5303 5.46967L16.5303 11.4697C16.8232 11.7626 16.8232 12.2374 16.5303 12.5303L10.5303 18.5303C10.2374 18.8232 9.76256 18.8232 9.46967 18.5303C9.17678 18.2374 9.17678 17.7626 9.46967 17.4697L14.9393 12L9.46967 6.53033C9.17678 6.23744 9.17678 5.76256 9.46967 5.46967Z"/>
        </svg>`;

      function change_arrow_icon (e){
        e.innerHTML = arrow_svg;
      };
      
      next_button.forEach(change_arrow_icon);
      
      const main_container = document.querySelector('#MainContent');
      const footer_height = document.querySelector('#shopify-section-footer').offsetHeight;
    
      //CSS min-height
      const main_container_min_height = 'calc(100vh - '+footer_height+'px)';
    
      main_container.style.minHeight = main_container_min_height;
    }
  }
});

/* Horizontal scroll on multicolumn infinite */

const horizontal_slider = document.querySelector('.infinite .overflow__container');
let isDown = false;
let startX;
let scrollLeft;

if(horizontal_slider){
  horizontal_slider.addEventListener('mousedown', (e) => {
    isDown = true;
    horizontal_slider.classList.add('active');
    startX = e.pageX - horizontal_slider.offsetLeft;
    scrollLeft = horizontal_slider.scrollLeft;
  });
  horizontal_slider.addEventListener('mouseleave', () => {
    isDown = false;
    horizontal_slider.classList.remove('active');
  });
  horizontal_slider.addEventListener('mouseup', () => {
    isDown = false;
    horizontal_slider.classList.remove('active');
  });
  horizontal_slider.addEventListener('mousemove', (e) => {
    if(!isDown) return;
    e.preventDefault();
    const x = e.pageX - horizontal_slider.offsetLeft;
    const walk = (x - startX) * 3; //scroll-fast
    horizontal_slider.scrollLeft = scrollLeft - walk;
  });
}


